import { Coordinator } from "./Coordinator";

export abstract class BaseCoordinator extends Coordinator{
        
    abstract start(): void;

}